// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Bu-z","tooltipWrapper":"Cu-z","icon":"Du-z","tooltip":"Eu-z","content":"Fu-z"};